import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux"
import { fetchSocialAccountCreatorsThunk } from "slices/socialAccounts/thunk";
import { AppDispatch, RootState } from "store";
import { formatNumber, generateUniqueKey, getSocialAccountProfileURL } from "utils/helpers";
import userProfilePicture from "../../../assets/images/users/user-dummy-img.jpg";
import Skeleton from "react-loading-skeleton";
import IGLogoPNG from "../../../assets/images/brands/ig-logo.png"
import { setCreatorsFilters } from "slices/socialAccounts/reducer";
import { defaultSocialAccountCreatorsFilters } from "types/social-account";
import FollowersIcon from "assets/icons/mono/FollowersIcon";
import { UncontrolledTooltip } from "reactstrap";
const SocialAccountCreators: React.FC<{ socialAccountId: string }> = ({ socialAccountId }) => {

    const dispatch: AppDispatch = useDispatch();
    const filters = useSelector((state: RootState) => state.socialAccountState.creators.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const [initialLoading, setInitialLoading] = useState(true);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const loading = useSelector((state: RootState) => state.socialAccountState.creators.loading);
    const creatorsData = useSelector((state: RootState) => state.socialAccountState.creators.items[socialAccountId!]?.filtered_lists?.[filterId!]);
    const hasMore = creatorsData?.has_more ?? true;
    const page = creatorsData?.page ?? 1;
    const creators = creatorsData?.items ?? [];
    const error = useSelector((state: RootState) => state.socialAccountState.creators.error);

    useEffect(() => {
        dispatch(setCreatorsFilters(defaultSocialAccountCreatorsFilters));
    }, [])

    useEffect(() => {
        if (socialAccountId && filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchSocialAccountCreatorsThunk({ socialAccountId, filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [socialAccountId, filters])

    const nextPage = () => {
        if (hasMore && socialAccountId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialAccountCreatorsThunk({ filters: { ...filters, page: nextPageNumber }, socialAccountId }))
        }
    }

    return (
        <div className="card">
            <InfiniteScroll
                dataLength={creators.length}
                next={nextPage}
                hasMore={hasMore}
                loader={<></>}
                className="w-100"
            >
                <table>
                    <thead>
                        <tr>
                            <th>Creator</th>
                            {/* <th>Followers</th> */}
                            <th>No. of Posts</th>
                            <th>Views</th>
                            <th>Likes</th>
                            <th>Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !initialLoading && creators.map((creator, i) => {
                                return (
                                    <tr className="border-bottom-1 px-3" key={i}>
                                        <td className="w-25">
                                            <div className="py-3">
                                                <div className="d-flex justify-content-start align-items-center gap-3 border-right-dashed td-content">
                                                    <div>
                                                        <div className='bgc-content bg-image cursor-pointer position-relative' style={{ backgroundImage: `url(${creator?.social_account?.profile_picture_url ?? userProfilePicture})`, height: '72px', width: '72px', borderRadius: '4px' }}>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column justify-content-center gap-1">
                                                        <div className="d-flex align-items-center gap-1">
                                                            {
                                                                creator.social_account?.platform === 'ig' &&
                                                                <img src={IGLogoPNG} alt="IG Logo" className='linked-posts-ig-logo' />
                                                            }
                                                            {
                                                                creator.social_account?.platform === 'yt' &&
                                                                <i className='ri-youtube-fill text-danger linked-posts-yt-logo mt-1'></i>
                                                            }
                                                            <span className='linked-post-posted-on'>{creator.social_account.name}</span>
                                                        </div>
                                                        <span className="d-flex align-items-center gap-2">
                                                            <a target="_blank" href={getSocialAccountProfileURL(creator.social_account.handle, creator.social_account.platform)} className='linked-posts-ig-username fw-normal' style={{ fontSize: '12px' }}>@{creator.social_account.handle}</a>
                                                        </span>
                                                        <span style={{ fontSize: '12px' }} className="d-flex align-items-center gap-1" id={`followers-${creator.social_account.uuid}`}><FollowersIcon /> <b>{formatNumber(creator.social_account.followers_count)}</b> Followers</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        {/* <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1 border-right-dashed td-content">
                                                    <span className="">{formatNumber(creator.social_account.followers_count)}</span>
                                                </div>
                                            </div>
                                        </td> */}
                                        <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1 border-right-dashed td-content">
                                                    <span className="">{formatNumber(creator.no_of_posts)}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1 border-right-dashed td-content">
                                                    <i className='ri-eye-line me-1'></i> <span className="">{formatNumber(creator.views_count)}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1 border-right-dashed td-content">
                                                    <i className='ri-heart-line me-1'></i> <span className="">{formatNumber(creator.like_count)}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1 td-content">
                                                    <i className='ri-chat-3-line me-1'></i> <span className="">{formatNumber(creator.comments_count)}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        {
                            (loading || initialLoading) &&
                            Array.from({ length: 10 }).map((_, i) => {
                                return (
                                    <tr>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                {
                    !(loading || initialLoading) && error &&
                    <div className="py-3 d-flex justify-content-center align-items-center">
                        <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                    </div>
                }
                {
                    !(loading || initialLoading) && creators.length === 0 &&
                    <div className="d-flex w-100 justify-content-center align-items-center my-5">
                        <div className="length-zero my-5">
                            <h3>Currently there is no creator in your list</h3>
                        </div>
                    </div>
                }
            </InfiniteScroll>
        </div>
    )
}

export default SocialAccountCreators
